import { render } from "./Index.vue?vue&type=template&id=db168d32&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=db168d32&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-db168d32"

export default script